export const isBlankSection = section => !!section && section.section_type === 'blank'
export const blankAllowed = section => !!(section && section.program_info && Number(section.program_info.allow_blanks) === 1)

export function restoreSectionIntent (section, bundles = []) {
  if (['blank', 'decorated'].includes(section.section_type)) return section
  const lines = section.style_lines || []
  let placements = (bundles.find(bundle => bundle.id === section.bundle_id) || {}).placements || section.decoration_sets || []
  if (!placements.length && lines.length && lines.every(line => Object.values(line.bundle_resolutions || {}).some(rows => rows.length))) placements = lines.flatMap(line => Object.values(line.bundle_resolutions || {}).flat())
  const hasDecoration = placements.some(placement => placement && (placement.design_mode || placement.artwork || placement.technique || placement.location))
  if (lines.length && lines.every(line => Number(line.blank_order) === 1) && !hasDecoration) section.section_type = 'blank'
  else if (placements.length && placements.every(placement => placement && placement.design_mode && placement.technique && placement.location && (placement.artwork || placement.decoration_text)) && !lines.some(line => Number(line.blank_order) === 1)) section.section_type = 'decorated'
  else section.section_type = ''
  return section
}

export function sectionIntentIssue (section) {
  if (!['blank', 'decorated'].includes(section.section_type)) return 'Confirm this Section’s merchandise intent. Missing artwork does not mean blank.'
  if (isBlankSection(section)) {
    if (section.bundle_id || (section.decoration_sets || []).length || (section.style_lines || []).some(line => (line.decoration_set_ids || []).length || Object.values(line.bundle_resolutions || {}).some(rows => rows.length))) return 'Blank Section contains decoration state. Remove this Section and recreate it with the intended merchandise type.'
    if (section.program_info && !blankAllowed(section)) return 'This Program does not allow blank merchandise.'
  }
  return ''
}

export function v2MerchandiseGroupKey (key, item) {
  return key + ':merchandise:' + (Number(item.blank_order) === 1 ? 'blank' : 'decorated')
}
